import * as React from "react";
import {Display} from "../../../components/Display";
import {Loader} from "../../../components/Utils/loader/Loader";
import './styles.scss'
import {CensusListContext} from "../../providers/CensusListProvider";
import {useNavigate} from "react-router-dom";
import {Button, Tooltip} from "@vebox/etui-core";
import {AppTranslations} from "../../../components/Utils/translations/AppTranslations";
import {userHasPermission} from "../../../components/Utils/RolesUtils";
import {CREATE_CENSUS_COOLER} from "../../Constants";
import {VeboxUser} from "../../../providers/VeboxUser";
import {DataResponse} from "../../../processes/massive_actions/CensusCooler/data/models/RestApi";
import {
    JSONCensusAvailabilityCheckResult
} from "../../../processes/massive_actions/CensusCooler/data/models/JSONCensusAvailabilityCheckResult";

declare var AppTranslations: AppTranslations

interface CensusTopMenuProps {
    isCensusFeatureAvailable: DataResponse<JSONCensusAvailabilityCheckResult>
}

export const CensusTopMenu: React.FC<CensusTopMenuProps> = ({isCensusFeatureAvailable}) => {
    const {isFetching, error, totalCount} = React.useContext(CensusListContext);
    const navigate = useNavigate();
    const loggedInUser = VeboxUser.useCurrentUser();

    const {data, isLoading} = isCensusFeatureAvailable;

    React.useEffect(() => {
        console.error(error);
    }, [error]);

    const createNewCensus = () => {
        if (data?.editable) {
            navigate("/newCensus")
        }
    }

    return (
        <div className={"census-top-menu-list"}>
            <span className={"item-count"}>
                    <Display isVisible={isFetching}>
                        <Loader spinnerSize={1} relativelyCentered={true}/>
                    </Display>
                    <Display isVisible={!isFetching}>
                        <span>
                            {!error && totalCount ? totalCount : 0}
                        </span>
                    </Display>
                {AppTranslations.massiveActions.censusCooler.items}
            </span>
            <div className={"flx-row flx-space-between gap-10"}>
                <Display
                    isVisible={!isLoading && data?.supported && userHasPermission(loggedInUser, CREATE_CENSUS_COOLER)}
                >
                    <Tooltip message={data?.errorMessage} disableToolTip={data?.editable} placement={"right"}>
                        <Button
                            style={{width: 57, height: 57, backgroundColor: data?.editable ? "#484848" : "#989898"}}
                            shape={"circle"}
                            disabled={!data?.editable}
                            onClick={createNewCensus}
                        >
                            <img
                                className="menu-action-button-img"
                                src="images/buttons/iconAddSmall.png"
                                style={{width: 25, height: 25, top: 16, left: 16, color: "white"}}
                                alt={"Create census"}
                            />
                        </Button>
                    </Tooltip>
                </Display>
            </div>
        </div>
    );
}